import { Comments } from '@/comments';
import { TableOfContents } from '@/table-of-contents';

$(document).ready(function() {
    Comments.init();
    Comments.initFormValidation({ 
        success: (response) => {
            if (!response.success) {
                return;
            }
            SaleHoo.TrackedEvents.track('blogAddComment');
        }
    });

    TableOfContents.init();
});
